import React from "react";
import { Box, Typography } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TodayIcon from "@mui/icons-material/Today";
import DateRangeIcon from "@mui/icons-material/DateRange";

const StatCard = ({ icon, value, label, gradient, delay = 0 }) => {
  return (
    <Box
      className="quick-stats__card"
      sx={{
        background: "rgba(255,255,255,0.95)",
        borderRadius: "16px",
        padding: "20px 16px",
        flex: 1,
        minWidth: "140px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        transition: "all 0.3s ease",
        position: "relative",
        overflow: "hidden",
        animation: `fadeSlideIn 0.5s ease ${delay}s both`,
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.35)",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
          background: gradient,
        },
      }}
    >
      <Box
        sx={{
          width: "48px",
          height: "48px",
          borderRadius: "14px",
          background: gradient,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: "#333",
          fontSize: "1.75rem",
        }}
      >
        {value}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "rgba(0,0,0,0.6)",
          textAlign: "center",
          fontSize: "0.8rem",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const QuickStats = ({ stats }) => {
  const statItems = [
    {
      icon: <AssignmentIcon sx={{ color: "#fff", fontSize: "24px" }} />,
      value: stats.totalTasks,
      label: "Active Tasks",
      gradient: "linear-gradient(135deg, #197B68 0%, #318b79 100%)",
    },
    {
      icon: <TodayIcon sx={{ color: "#fff", fontSize: "24px" }} />,
      value: stats.completedToday,
      label: "Done Today",
      gradient: "linear-gradient(135deg, #813773 0%, #a04990 100%)",
    },
    {
      icon: <DateRangeIcon sx={{ color: "#fff", fontSize: "24px" }} />,
      value: stats.completedThisWeek,
      label: "This Week",
      gradient: "linear-gradient(135deg, #276580 0%, #3f7891 100%)",
    },
    {
      icon: <CheckCircleIcon sx={{ color: "#fff", fontSize: "24px" }} />,
      value: stats.completedTotal,
      label: "All Time",
      gradient: "linear-gradient(135deg, #429254 0%, #5ab06a 100%)",
    },
  ];

  return (
    <Box
      className="quick-stats"
      sx={{
        marginBottom: "16px",
      }}
    >
      <Box
        className="quick-stats__cards"
        sx={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        {statItems.map((item, index) => (
          <StatCard key={item.label} {...item} delay={index * 0.1} />
        ))}
      </Box>
    </Box>
  );
};

export default QuickStats;
